'use client'

import Pagenation from "@/components/common/pagenation"
import { PointListType } from "@/type/list"
import api from "@/util/api"
import { useContext, useEffect, useState } from "react"
import verified_rank from "@/public/image/etc/verified_rank.png"
import { with_comma } from "@/util/comma"
import Lottie from "react-lottie-player"
import loadingJson from "@/public/media/load_data.json"
import { usePathname, useRouter, useSearchParams } from "next/navigation"
import { SettingContext } from "@/context/siteContext"
import { AuthContext } from "@/context/authContext"
import customAlert from "@/util/customAlert"
import ListV2 from "@/components/board/list_v2"
import moment from "moment";
import Slider from "@/components/common/swiper2"
import { SwiperSlide } from "swiper/react"
import { useTranslations } from "next-intl"
import LocaleFormat from "@/components/etc/localeFormat"

export default function PointList({ type, sideBoard, isSwipe }: { type: number, sideBoard?: boolean, isSwipe?:boolean }) {
    const [list, setList] = useState<PointListType[]>([])
    const [page, setPage] = useState<number>(1)
    const [totalCount, setTotalCount] = useState<number>(1)
    const perPage = sideBoard ? 6 : 12

    const t = useTranslations("Text")
    const a = useTranslations("Sentence")

    const [mount, setMount] = useState<boolean>(false)
    const [loading, setLoading] = useState<boolean>(true)

    const pathName = usePathname()
    const params = useSearchParams()
    const { setting } = useContext(SettingContext);
    const { user, setUser } = useContext(AuthContext)
    const router = useRouter()

    function fetchData() {

        const url = type == 3 ? `/api/pointexchange/request/list/` : `/api/pointexchange/list/?type=${type}&page=${page}&page_count=${perPage}`;
        api(url)
            .then(res => res.json())
            .then(({ data }) => {
                // console.log("***data:", data.objects)
                setList(data?.objects ?? [])
                setTotalCount(data?.total_count ?? 1)
                setLoading(false)
            })
    }

    async function copyCopon(couponNumber:string){
        
        try {
            await navigator.clipboard.writeText(couponNumber);
            // console.log("복사 완료");
            customAlert(a("couponCopied"), 'success')
        } catch (err) {
            // console.warn("복사 실패 (무시):", err);
            customAlert(a("errorTryAgainLater"), 'warning')
        }
    }

     async function requestPointExcahnge(id: number) {
        if(!user.is_authenticated){
            customAlert(a("NeedLogin"), 'warning')
            return;
        }
        await customAlert(a("confirmPointConversion"), "question", () => {

            const formData = new FormData();
            formData.set('id', `${id}`)
            api(`/api/pointexchange/request/`, { method: "POST", body: formData })
                .then(res => res.json())
                .then(async ({status_code, status, message, data}) => {
                    console.log(data)
                    let requestMessage = message
                    if(status_code == 200){
                        requestMessage = `<div>${a("pointConversionRequested")}</div>`;

                        //제휴스폰의 경우 쿠폰번호를 안내함
                        if(data.product_type == 2){
                            requestMessage += `
                            <div style="padding:20px 10px;font-size:1.2em;border:1px solid #000;margin:5px 0;">${t("쿠폰번호")} : ${data.coupon}</div>
                            <small style="color:red;">(${a("CopiedCoupon")})</small>
                            <div style="margin-top:10px;">※ ${a("UsedCouponBefore")}</div>`;
                        }
                        
                       try {
                            await navigator.clipboard.writeText(data.coupon);
                            // console.log("복사 완료");
                        } catch (err) {
                            // console.warn("복사 실패 (무시):", err);
                        }
                    }
                    customAlert(requestMessage, status, undefined, {htmlMode : true})

                })
                .catch(e=> {
                    customAlert(a("ErrorRequest"), 'warning')
                })
        }, {
            confirmMode: true,
            onCancel: () => {return false},
        });
    }
    async function canclePointExcahnge(id: number) {

        const box = document.querySelector(`.contentsArea[data-id="${id}"]`);
        const span = box?.querySelector('.statusSpan') ;
        const status = span?.textContent ;
        console.log(id, status, box, span)
        if(span && status != "대기 중"){
            customAlert(a("requestAlreadyProcessed"),"warning");
            return false;
        }


        await customAlert(a("confirmCancelPointConversion"), "question", () => {
            const formData = new FormData();
            formData.set('id', `${id}`)
            api(`/api/pointexchange/cancel/`, { method: "POST", body: formData })
                .then(res => res.json())
                .then(({status_code, status, message, data}) => {
                    let requestMessage = message
                    // if(status_code == 200){
                    //     requestMessage = "포인트 전환 신청 되었습니다."
                    // }
                    customAlert(message, status, ()=>{fetchData() })
                })
                .catch(e=> {
                    customAlert(a("ErrorRequest"), 'warning')
                })
        }, {
            confirmMode: true,
            onCancel: () => {return false},
        });
        
    }

    useEffect(() => {
        if(!user.is_authenticated && type == 3) router.push('/');
    }, [user, type])

    useEffect(() => {
        setMount(true)
        fetchData();
    }, [page])

    useEffect(() => {
        if (!mount) return;
        setLoading(true)
        fetchData()
    }, [pathName, params])

    // const telegram = setting?.banners?.find(b => b.name === '텔레그램') ?? null;
    // useEffect(() => {
    //     //console.log("setti :::", telegram) ;
    // }, [telegram])
    

    return (
        <>

        {/* 신청현황 */}
        {type == 3 ? 
            
            <ListV2 list={list}
                loading={loading}
                className={`pointStatusList`}
                // setContent={canclePointExcahnge}
                setContent={()=>{}}>

                {(item: any, idx: number) => (
                    <>
                        <div className="contentsArea flex center" data-id={item.id}>
                            <div className="info w-70-per">
                                <div className={`subject`}>
                                    [{t(item.product_type)}] {item.product_name} {item.id}
                                </div>
                                <div className={`normal m-t-8`}>
                                    <div className={`m-r-10`}>Point : {with_comma(item.point_cost)}P</div>
                                    <div>{t("상태")} : <span className={`statusSpan`} style={item.status=="완료"||item.status=="대기 중"?item.status=="대기 중"?{color:"blue"}:{color:"green"}:{color:"red"}}>{t(item.status)}</span> </div>
                                </div>
                                <div className={`auth`}>
                                    {item.coupon && <div>{t("쿠폰번호")} : {item.coupon}</div> }
                                    <div className={`m-r-10`}>{t("신청일")} : {<LocaleFormat date={item.create_dt} format={"YYYY-MM-DD"} />}</div>
                                    <div>{t("처리일")} : {item.status != "대기 중" && <LocaleFormat date={item.update_dt} format={"YYYY-MM-DD"} />}</div>
                                </div>
                            </div>
                                <div className={`pointStatusBtns w-30-per`}>
                                    {item.status == "대기 중" &&
                                        <>
                                        {item.coupon && <button className={`copy`} onClick={()=>{copyCopon(item.coupon)}}>{t("쿠폰번호 복사")}</button>}
                                        <button className={`cancle`} onClick={()=>{canclePointExcahnge(item.id)}}>{t("신청 취소")}</button>
                                        </>
                                    }
                                </div>
                        </div>
                    </>
                )}
            </ListV2>
        :
        // 포인트전환,제휴쿠폰 페이지

            // 메인롤링
            isSwipe?

                <div className="main_point-list-container">
                    <Slider titleUrl="">
                        {
                            list.map((el, idx) => (
                            <SwiperSlide key={idx} style={{ width: "160px" }} 
                                         onClick={()=>{requestPointExcahnge(el.id)}}>
                                <div className="inner">
                                    <div className="list-thumbnail">
                                        <img src={el.image||"/image/etc/no-image.png"} 
                                            alt={el.name}
                                            onError={(e) => {
                                                e.currentTarget.onerror = null;
                                                e.currentTarget.src = "/image/etc/no-image.png";
                                            }} />
                                    </div>
                                </div>
                                <footer>
                                    {
                                        type == 2
                                            ?
                                            <div className={`exchange`}>
                                                <p>{t("전환포인트")}</p>
                                                <p>{with_comma(el.point_cost)} P</p>
                                            </div>
                                            :
                                            <div>
                                                <p>{el.name}</p>
                                                <p>{with_comma(el.point_cost)} P</p>
                                            </div>
                                    }
                                </footer>
                            </SwiperSlide>
                            ))
                        }
                    </Slider>
                </div>
            
            :

                // 상세페이지
                <ListV2 list={list}
                    className={"point-list-container"}
                    loading={loading}
                    setContent={requestPointExcahnge}>

                    {(item: any, idx: number) => (
                        <>
                            {/* <div className="onClick-cover" onClick={e => requestPointExcahnge(item.id)}></div> */}
                            <div className="inner">
                                <div className="list-thumbnail">
                                    <img src={item.image||"/image/etc/no-image.png"} 
                                        alt={item.name}
                                        onError={(e) => {
                                            e.currentTarget.onerror = null;
                                            e.currentTarget.src = "/image/etc/no-image.png";
                                        }} />
                                </div>
                            </div>
                            <footer>
                                {
                                    type == 2
                                        ?
                                        <div className={`exchange`}>
                                            <p>{t("전환포인트")}</p>
                                            <p>{with_comma(item.point_cost)} P</p>
                                        </div>
                                        :
                                        <div>
                                            <p>{item.name}</p>
                                            <p>{with_comma(item.point_cost)} P</p>
                                        </div>
                                }
                            </footer>
                        </>
                    )}
                </ListV2>
        }
        </>
            
    )
}